// const userAgent = navigator.userAgent.toLowerCase();
// const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

export const mediumScreenSizeDetection = () => window.innerWidth <= 768 && window.innerWidth > 375;
